import type { PageBankCardType } from '@/components/ClearCardComp';
import { LoanType, PaymentDTO } from '@/interface/CL/clCredit';
import { LittleBank } from '@/interface/KKC/repayment';
import { creditApply } from '@/pages/CL/credit/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  creditApply: creditApply;
  withdrawlOrderId: string;
  stateHasChange: boolean;
  slaPopupHasShow: boolean;
  loanParams?: PaymentDTO;
  eddaCacheBank?: {
    bank: LittleBank;
    bankNum: string;
  }; // 缓存银行信息,放款因为Edda失败的情况下，直接展示这些缓存信息。
  commonErrorMsg?: {
    title?: string;
    message?: string;
  }; // 在CL中遇到的通用的报错信息
  loanType?: LoanType | string;
  bankListFromApprovalSuccess: PageBankCardType[];
}

const initialState: CommonState | null = {
  creditApply: {
    id: '',
  },
  slaPopupHasShow: false,
  withdrawlOrderId: '',
  stateHasChange: false,
  loanParams: undefined,
  loanType: '',
  bankListFromApprovalSuccess: [],
};

const clCreditSlice = createSlice({
  name: 'clCredit',
  initialState,
  reducers: {
    setCreditApply(state: any, action: PayloadAction<{ creditApply: creditApply }>) {
      state.creditApply = action.payload.creditApply;
    },
    setWithdrawlOrderId(state: any, action: PayloadAction<{ orderId: string }>) {
      state.withdrawlOrderId = action.payload.orderId;
    },
    setStateHasChange(state: CommonState, action: PayloadAction<boolean>) {
      state.stateHasChange = action.payload;
    },
    setLoanParams(state: CommonState, action: PayloadAction<PaymentDTO | undefined>) {
      state.loanParams = { ...state.loanParams, ...action.payload };
    },
    setEddaCacheBank(
      state: CommonState,
      action: PayloadAction<{ bank: LittleBank; bankNum: string }>
    ) {
      state.eddaCacheBank = action.payload;
    },
    clearEddaCacheBank(state: CommonState) {
      state.eddaCacheBank = undefined;
    },
    setClCommonErrorMsg(
      state: CommonState,
      action: PayloadAction<{ title?: string; message?: string }>
    ) {
      state.commonErrorMsg = action.payload;
    },
    setSlaPopupHasShow(state: CommonState) {
      state.slaPopupHasShow = true;
    },
    setLoanType(state: CommonState, action: PayloadAction<{ loanType: LoanType | string }>) {
      state.loanType = action.payload.loanType;
    },
    setBankListFromApprovalSuccess(state: CommonState, action: PayloadAction<PageBankCardType[]>) {
      state.bankListFromApprovalSuccess = action.payload;
    },
  },
});

const {
  setCreditApply,
  setWithdrawlOrderId,
  setStateHasChange,
  setLoanParams,
  setEddaCacheBank,
  clearEddaCacheBank,
  setClCommonErrorMsg,
  setSlaPopupHasShow,
  setLoanType,
  setBankListFromApprovalSuccess,
} = clCreditSlice.actions;

export {
  setCreditApply,
  setWithdrawlOrderId,
  setStateHasChange,
  setLoanParams,
  setEddaCacheBank,
  clearEddaCacheBank,
  setClCommonErrorMsg,
  setSlaPopupHasShow,
  setLoanType,
  setBankListFromApprovalSuccess,
};

export default clCreditSlice.reducer;
